import type { Question, FeedbackForm, AIGeneratedQuestion } from '@/services/PagesServices/FeedbackManagementService';

export type { Question, FeedbackForm, AIGeneratedQuestion };

export type QuestionType = 'short_text' | 'paragraph' | 'multiple_choice_single' | 'multiple_choice_multi' | 'star_rating' | 'slider';
export type FormType = 'feedback' | 'satisfaction' | 'assessment';
export type AssessmentType = 'objective' | 'subjective' | 'both';
export type AIDifficulty = 'easy' | 'medium' | 'hard' | 'mixed';

export interface LocalQuestion {
  id: string;
  type: QuestionType;
  text: string;
  required: boolean;
  options?: string[];
  correctAnswers?: number[];
  score?: number;
  sliderMin?: number;
  sliderMax?: number;
}

export interface FormBuilderService {
  createForm: (formData: Omit<FeedbackForm, 'id' | 'uuid' | 'slug'>) => Promise<{ success: boolean; error?: string; data?: { slug?: string } }>;
  updateForm: (id: string, formData: Partial<FeedbackForm>) => Promise<{ success: boolean; error?: string }>;
  clearCurrentForm: () => void;
}

export interface FormBuilderStoreState {
  currentForm: FeedbackForm | null;
  editingFormId: string | null;
  saving: boolean;
  error: string | null;
}

export const QUESTION_TYPES: { value: QuestionType; label: string }[] = [
  { value: 'short_text', label: 'Short Text' },
  { value: 'paragraph', label: 'Paragraph' },
  { value: 'multiple_choice_single', label: 'Multiple Choice (Single)' },
  { value: 'multiple_choice_multi', label: 'Multiple Choice (Multi)' },
  { value: 'star_rating', label: 'Star Rating' },
  { value: 'slider', label: 'Slider' },
];
